function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
//Limitless imports
import { PortalButton } from "../../..";
import { useTranslation } from "@limitless/common/hooks";
import { useCountdown } from "@limitless/common/hooks/countdown/CountdownHook";
const FooterCountdownButton = ({
  countdownValue,
  onClick,
  label,
  ...rest
}) => {
  const {
    t
  } = useTranslation();
  const {
    timer
  } = useCountdown(countdownValue, onClick);
  return /*#__PURE__*/React.createElement(PortalButton, _extends({
    onClick: onClick
  }, rest), t(label), " ", timer ? `(${timer})` : "");
};
export default FooterCountdownButton;
FooterCountdownButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  countdownValue: PropTypes.number
};
FooterCountdownButton.defaultProps = {
  countdownValue: 5
};